/**
 * @method: View Switcher Component
 * @author: CDL
 * @Version: 1.0
 * */
export default class ViewSwitcher {
    constructor() {
        // console.log('View Switcher');

        this.state = {
            images: {},
        };

        this.initHandlers();
    }

    initHandlers() {
        window.state = this.state;

        // change products layout
        // $('.js-view-switcher .switcher').click(function () {
        //     console.log('switch views');
        //     if ($('ul.basic-grid').length === 1) {
        //         $('ul.basic-grid').addClass('basic-list').removeClass('basic-grid');
        //     } else {
        //         $('ul.basic-list').addClass('basic-grid').removeClass('basic-list');
        //     }
        // });

        $('#js-gridview-button').click(function () {
            console.log('activate grid-view');
            $('#js-listview-button').removeClass('active');
            $(this).addClass('active');
            $('.js-toggle-grid').addClass('grid-view').removeClass('list-view');
        });

        $('#js-listview-button').click(function () {
            console.log('activate list view');
            $('#js-gridview-button').removeClass('active');
            $(this).addClass('active');
            $('.js-toggle-grid').removeClass('grid-view').addClass('list-view');
            // $(".content-image").detach();
        });
    }
}
